module.exports = __webpack_public_path__ + "static/media/home-solid.d1abacc5.svg";